package com.wintermar.inspection.core.ui.component.snackbar.util

data class SnackBarState(
    val message: String,
    val variant: SnackBarVariant = SnackBarVariant.INFO,
    val position: SnackBarPosition = SnackBarPosition.TOP,
    val actionValue: String? = null,
    val maxWidth: Float = 1f,
    val onAction: () -> Unit = {}
)
